// 詢問是否開新視窗連到外站網頁，目前只針對ionex的網址詢問 // 目前會執行詢問的：所有電動車機種、最新消息選單ionex的項目、服務據點選單ionex的項目

<template>
  <div v-if="isopen" class="modal" id="openNewWindow" @click.stop="closeModal">
    <div class="modal-dialog" @click.stop="clickModal">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <h5 class="modal-title"><span class="modal-title-icon"><img src="@/modules/ui/message/icon-warning.svg" alt="" height="30" /></span>提醒訊息</h5> -->
          <button type="button" class="close" @click.stop="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="messageInfo">
            <!-- 預設的內容 -->
            <img src="@/assets/event/openNewWindow/message_ionex.png" alt="" class="messageTitle pc_block">
            <img src="@/assets/event/openNewWindow/message_ionex_s.png" alt="" class="messageTitle md_block">
          </slot>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click.stop="closeModal"></button>
          <button type="button" class="btn btn-primary" @click.stop="openWindow"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
#openNewWindow.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

#openNewWindow .modal-dialog {
  position: relative;
  max-width: 500px;
  width: 80%;
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  z-index: 999;
  pointer-events: none;
}

#openNewWindow .modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.3rem;
  outline: 0;
  background-color: #27a7e1;
  background-image: url('~@/assets/event/openNewWindow/message_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 38vw;
  max-height: 200px;
  background-position: center top;
}

.pc_block {
  display: block;
}
.md_block {
  display: none;
}

#openNewWindow .modal-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem 1rem;
}
#openNewWindow .messageTitle {
  width: 56vw;
  max-width: 324px;
}
#openNewWindow .modal-body {
  position: absolute;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
  text-align: center;
  top: 18%;
  left: 50%;
  transform: translate(-50%);
}

#openNewWindow .modal-footer {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 18%;
}

#openNewWindow .modal-footer > :not(:last-child) {
  margin-right: 1.5rem;
}
#openNewWindow button {
  /* 初始button */
  padding: 0;
  height: auto;
}
#openNewWindow button.btn {
  cursor: pointer;
  max-width: 109px;
  max-height: 31px;
  width: 16.8vw;
  height: 4.5vw;
  border: none;
  background-size: contain !important;
  transition: all 0.2s;
  position: relative;
}
#openNewWindow .btn:hover {
  filter: drop-shadow(0px 2px 0px #666);
}

#openNewWindow .btn-secondary {
  background: url('~@/assets/event/openNewWindow/button_cancel.png') no-repeat center;
}

#openNewWindow .btn-primary {
  background: url('~@/assets/event/openNewWindow/button_go.png') no-repeat center;
}

#openNewWindow .modal-header .close {
  float: right;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background-color: transparent;
  border: 0;
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
  cursor: pointer;
}
#openNewWindow .modal-header .close:hover {
  color: #000;
  opacity: 0.5;
}
#openNewWindow .modal-title {
  font-size: 1.5rem;
}
#openNewWindow p,
#openNewWindow button {
  font-size: 1.2rem;
  font-weight: 600;
}
#openNewWindow .modal-title-icon img {
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: middle;
  margin-right: 0.5rem;
}

@media (max-width: 767px) {
  #openNewWindow .modal-content {
    background-image: url('~@/assets/event/openNewWindow/message_bg_s.png');
    height: 90vw;
    max-height: 100%;
  }
  .pc_block {
    display: none;
  }
  .md_block {
    display: block;
  }
  #openNewWindow .modal-dialog {
    top: 38%;
  }
  #openNewWindow .modal-body {
    top: 20%;
  }
  #openNewWindow .modal-footer {
    bottom: 12%;
  }
  #openNewWindow .messageTitle {
    width: 38vw;
    height: auto;
  }
  #openNewWindow .modal-footer {
    flex-direction: column;
  }
  #openNewWindow button.btn {
    background-color: #fff;
    border-radius: 8px;
    max-width: 160px;
    max-height: 50px;
    width: 30.8vw;
    height: 9.5vw;
  }
  #openNewWindow .modal-footer > :not(:last-child) {
    margin-right: unset;
    margin-top: 1.5rem;
  }
  #openNewWindow .btn-secondary {
    order: 1;
  }
  #openNewWindow .modal-header .close {
    font-size: 3rem;
  }
}
@media (orientation: landscape) and (max-width: 767px) {
  #openNewWindow .modal-dialog {
    top: 50%;
  }
  #openNewWindow .modal-body {
    top: 17%;
  }
  #openNewWindow .modal-footer {
    bottom: 10%;
  }
  #openNewWindow .modal-content {
    height: 90vw;
    max-width: 500px;
    max-height: 100vh;
  }
  #openNewWindow .messageTitle {
    max-width: 200px;
  }
}
@media (orientation: landscape) and (max-height: 374px) {
  #openNewWindow .messageTitle {
    max-width: 150px;
  }
  #openNewWindow button.btn {
    max-width: 150px;
    max-height: 40px;
  }
}
</style>

<script>
export default {
  props: {
    isopen: Boolean,
    openhref: {
      type: String,
      default: ''
    },
  },
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit('close_modal', false)
    },
    clickModal() {
      // 防止冒泡觸發closeModal()
    },
    openWindow() {
      const vm = this
      // console.log(this.openhref)  //原本設定要前往的a標籤href
      // 目前只針對電子車機種會詢問，並統一轉址到ionex的官網，之後如有變動再修改
      if (vm.openhref === '') {
        window.open('https://www.ionex.com.tw/')
        ga('send', 'event', location.pathname, 'to-ionex', 'to-ionex')
      } else {
        if (vm.openhref === 'https://www.ionex.com.tw/') {
          ga('send', 'event', location.pathname, 'to-ionex', 'to-ionex')
        }
        window.open(vm.openhref)
      }

      vm.$emit('close_modal', false)
    },
  },
}
</script>
